import { fetchURL } from './surveyConfigurationState';

export const differences = {
  all: [],
  surveyRequest: {},
  byQuestionId: {},
  thankYouPage: [],
};

const initialState = {
  updatedAt: undefined,
  configurationHash: undefined,
  publishedHash: undefined,
  publishedConfiguration: {},
  globalMarketingSettings: {},
  requestStatus: {
    loading: false,
    error: false,
    pending: false,
  },
  filterOptions: {},
  previewParameters: {
    page: undefined,
    question: undefined,
    option: undefined,
    employee_id: undefined,
  },
  previewContext: {},
  availableQuestions: [],
  processingOverride: false,
  differences,
};

export const previewOptionsState = (state = initialState, action) => {
  switch (action.type) {
    case 'previewOptionsState/SET_UPDATED_AT': {
      const { updatedAt } = action;

      return {
        ...state,
        updatedAt,
      };
    }

    case 'UPDATE_SURVEY_CONFIG_HASHES': {
      const { configurationHash, publishedHash } = action;

      return {
        ...state,
        configurationHash,
        publishedHash,
      };
    }

    case 'UPDATE_PREVIEW_PARAMETERS': {
      const { newParams } = action;

      return {
        ...state,
        previewParameters: { ...state.previewParameters, ...newParams },
      };
    }

    case 'SET_PREVIEW_OPTIONS_AND_DEFAULTS': {
      const {
        filterOptions,
        configurationHash,
        publishedHash,
        publishedConfiguration,
        globalMarketingSettings,
        availableQuestions,
        defaultLanguage,
      } = action;

      const previewParameters = {};
      Object.keys(filterOptions).forEach(key => {
        if (key === 'language' && defaultLanguage) {
          const defaultLangInOptions = filterOptions[key].options.find(
            option => option.value === defaultLanguage
          );
          if (defaultLangInOptions) {
            previewParameters[key] = defaultLanguage;
            return;
          }
        }

        previewParameters[key] = filterOptions[key].options[0].value;
      });

      return {
        ...state,
        filterOptions,
        previewParameters,
        configurationHash,
        publishedHash,
        publishedConfiguration,
        globalMarketingSettings,
        availableQuestions,
      };
    }

    case 'SET_PREVIEW_CONTEXT': {
      return {
        ...state,
        previewContext: action.context,
      };
    }

    case 'previewOptionsState/SET_PROCESSING_OVERRIDE': {
      return {
        ...state,
        processingOverride: action.processingOverride,
      };
    }

    case 'previewOptionsState/SET_REQUEST_STATUS': {
      const { newStatus } = action;

      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          ...newStatus,
        },
      };
    }

    case 'previewOptionsState/UPDATE_PUBLISHED_CONFIGURATION': {
      return {
        ...state,
        publishedConfiguration: action.publishedConfiguration,
      };
    }

    case 'previewOptionsState/SET_DIFFERENCES': {
      return {
        ...state,
        differences: action.differences,
      };
    }

    default:
      return state;
  }
};

export default previewOptionsState;

export const fetchPreviewContext = queryParameters => dispatch =>
  fetchURL(dispatch, `/api/v1/survey_previews?${queryParameters}`).then(response => {
    if (response && response.context) {
      dispatch({
        type: 'SET_PREVIEW_CONTEXT',
        context: response.context,
      });
    }
  });
